import React from 'react';

import type { ManufacturerCardFieldContainerBaseProps as ManufacturerAddCardFieldContainerProps } from '../../types/ManufacturerAddCardFieldContainerProps';
import { transformMedicationOptions } from '../../utils/transformMedicationOptions';
import { isManufacturerCardTypeEnabled } from '../../utils/isManufacturerCardTypeEnabled';

import ManufacturerCardCheckbox from './ManufacturerCardCheckbox';
import MedicationSelectorDropdown from './MedicationSelectorDropdown';

const ManufacturerAddCardFieldContainer: React.FC<
  ManufacturerAddCardFieldContainerProps
> = ({
  manufacturerCardCheckboxProps,
  medicationSelectorDropdownProps,
  cardCategoriesConfigObject,
}) => {
  if (
    !isManufacturerCardTypeEnabled(cardCategoriesConfigObject)
  ) {
    return null;
  }

  const transformedMedicationOptions =
    transformMedicationOptions(
      medicationSelectorDropdownProps.options,
    );

  return (
    <>
      <ManufacturerCardCheckbox
        {...manufacturerCardCheckboxProps}
      />
      {manufacturerCardCheckboxProps.value ? (
        <MedicationSelectorDropdown
          {...medicationSelectorDropdownProps}
          options={transformedMedicationOptions}
        />
      ) : null}
    </>
  );
};

export default ManufacturerAddCardFieldContainer;
